// extracted by mini-css-extract-plugin
export default {"container":"InvestigationAssets_container__sTB3h"};